import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose } from '@travel-frontend/icons';
import { Hotline } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Hotline/index.js';
import { Container } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Container.js';
import { Control } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Control.js';
import { Container as HotlineContainer } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Desktop/components/Container.js';
import { LabelSmall } from '../../../../../../../../primitives/index.js';
export const LayoutDesktop = ({
  phoneNumber,
  handleClick,
  openingHours,
  imageUrl,
  headline
}) => _jsxs(Container, {
  children: [imageUrl && _jsx("img", {
    src: imageUrl,
    alt: ""
  }), _jsxs(HotlineContainer, {
    children: [_jsx(LabelSmall, {
      color: "contentInversePrimary",
      children: headline
    }), _jsx(Hotline, {
      openingHours: openingHours,
      phoneNumber: phoneNumber,
      children: phoneNumber
    })]
  }), _jsx(Control, {
    onClick: handleClick,
    children: _jsx(IconClose, {})
  })]
});